import {Card, CardMedia, CardProps} from "@mui/material";
import {WorkModelDocument} from "../../../../types/pj1dbApiWork";
import {MODEL_BG_COLOR} from "../../../../constants/work";
import {pickImageUrlFromModel} from "../../../../utils/workUtil";

export interface WorkModelistItemProps extends CardProps {
  item: WorkModelDocument;
}

export default function WorkModelistItem({item, ...props}: WorkModelistItemProps) {
  // const pickModelImages = (models: WorkModelDocument[]): string[] => models
  //   .map(model => props.work.url?.[model.attr[workAttrList.modelId.key]])
  //   .filter((url): url is string[] => url !== null)
  //   .flat() ?? []

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Card {...props} sx={{p: 0, m: 0, width: 180, height: '100%', ...props.sx}}>
      <CardMedia
        component="img"
        height="180"
        image={pickImageUrlFromModel(item)}
        alt='対象物画像'
        sx={{objectFit: "scale-down", backgroundColor: MODEL_BG_COLOR}}
      />
    </Card>
  )
}
